import {
  goToConnectPlatform,
  goToEpicProfile,
  goToFarcanaProfile,
  goToProfile,
  goToXboxProfile,
} from '@/app/routing/events'
import { PlatformType } from '@/entities/platforms/types'

export const steamRouter = (status: PlatformType['status']) => {
  if (status === 'Available') {
    return goToConnectPlatform({ platform: 'steam' })
  }
  if (status === 'Connected') {
    return goToProfile()
  }
}

export const egsRouter = (status: PlatformType['status']) => {
  if (status === 'Available') {
    return goToConnectPlatform({ platform: 'egs' })
  }
  if (status === 'Connected') {
    return goToEpicProfile()
  }
}

export const xboxRouter = (status: PlatformType['status']) => {
  if (status === 'Available') {
    return goToConnectPlatform({ platform: 'xbox' })
  }
  if (status === 'Connected') {
    return goToXboxProfile();
  }
}

export const farcanaRouter = (status: PlatformType['status']) => {
  if (status === 'Available') {
    return goToConnectPlatform({ platform: 'farcana' })
  }
  if (status === 'Connected') {
    return goToFarcanaProfile()
  }
}
